import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { LogFirebase } from "../../../../../services/firestore";
import { TRACK_SUBSCRIBE_FOR } from "../../../../../constants/Constants";
import { handleTrackSubscriptionFailed } from "./handleTrackSubscriptionFailed";
import { VideoSubscriptionTrackFailedModals } from "../../../../CommonModals/VideoTrackFailedModals";

const TrackSubscriptionFailed = ({ error, track }) => {
    useEffect(() => {
        handleTrackSubscriptionFailed(error, track, TRACK_SUBSCRIBE_FOR.LOCAL);
        LogFirebase("TwilioEvents", "trackSubscriptionFailedFromlocal", {
            track_details: track.kind,
            error_message: error.message,
        });
    }, [error, track]);

    return <VideoSubscriptionTrackFailedModals />;
};

TrackSubscriptionFailed.propTypes = {
    track: PropTypes.any,
    error: PropTypes.any,
};
export default TrackSubscriptionFailed;
